// API
const API_BASE = 'https://api.horocosmo.store/api/certificates'
 
// DOM
const $ = {
    input: document.getElementById('checkcart_certInput'),
    button: document.getElementById('checkcart_verifyBtn'),
    card: document.getElementById('checkcart_resultCard'),
    idle: document.getElementById('checkcart_stateIdle'),
    loading: document.getElementById('checkcart_stateLoading'),
    notFound: document.getElementById('checkcart_stateNotFound'),
    apiError: document.getElementById('checkcart_stateApiErr'),
    error: document.getElementById('checkcart_errMsg'),
    image: document.getElementById('checkcart_rImage'),
    placeholder: document.getElementById('checkcart_rImgPlaceholder'),
    zoom: document.getElementById('checkcart_zoomHint'),
    title: document.getElementById('checkcart_rGemName'),
    report: document.getElementById('checkcart_rReportLabel'),
    table: document.getElementById('checkcart_certTableBody'),
    lightbox: document.getElementById('checkcart_lightboxOverlay'),
    lightboxImg: document.getElementById('checkcart_lightboxImg'),
    lightboxCaption: document.getElementById('checkcart_lightboxCaption'),
    lightboxClose: document.getElementById('checkcart_lightboxClose')
};
 
// States
const STATES = [$.idle, $.loading, $.notFound, $.apiError, $.card];
 
// Show state
const showState = active => {
    STATES.forEach(el => { if (el) el.classList.remove('visible'); });
    active.classList.add('visible');
};
 
// Format label
const formatLabel = text =>
    text.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
 
// Check if a value is present (not blank / null / "null")
const hasValue = value =>
    value !== null &&
    value !== undefined &&
    String(value).trim() !== '' &&
    String(value).trim().toLowerCase() !== 'null';
 
// Return display value or fallback dash
const getValue = value => hasValue(value) ? value : '—';
 
// Image fallback
const imageFallback = () => {
    $.image.style.display = 'none';
    $.placeholder.style.display = 'flex';
    $.zoom.style.display = 'none';
};
 
 
/* ============================================================
   MULTI-VALUE HANDLING (Species / Variety)
   ============================================================ */
 
// How several values inside one cell are joined.
//   ', '  -> "Corundum, Beryl"        (single line)
//   '\n'  -> each value on its own line
const MULTI_VALUE_JOIN = ', ';
 
// Label used when only ONE of species / variety has been filled in
const COMBINED_SV_LABEL = 'Species & Variety';
 
// Separators an admin might type between multiple values
const VALUE_SPLIT_RE = /\s*[,;|\/]\s*/;
 
// Turn a raw field into a clean list of values.
// Accepts: a real array, a JSON-array string ('["Corundum","Beryl"]'),
// or a plain string separated by , ; | or /
const toList = raw => {
    if (raw === null || raw === undefined) return [];
 
    let items;
 
    if (Array.isArray(raw)) {
        items = raw;
    } else {
        const text = String(raw).trim();
 
        // An array that arrived as a JSON string
        if (/^\[[\s\S]*\]$/.test(text)) {
            try {
                const parsed = JSON.parse(text);
                if (Array.isArray(parsed)) return toList(parsed);
            } catch (e) { /* not JSON — fall through to plain splitting */ }
        }
 
        items = text.split(VALUE_SPLIT_RE);
    }
 
    const clean = [];
 
    items.forEach(item => {
        const value = (item === null || item === undefined) ? '' : String(item).trim();
        const lower = value.toLowerCase();
 
        if (value === '' || lower === 'null' || lower === 'undefined') return;
 
        // de-duplicate, ignoring case, keeping the first spelling
        if (!clean.some(existing => existing.toLowerCase() === lower)) clean.push(value);
    });
 
    return clean;
};
 
// Collect every value for a field, whichever shape the API used:
//   species          -> "Corundum, Beryl"  or  ["Corundum","Beryl"]
//   species_list     -> same
//   species_1, species_2, species-3 ...
const collectField = (data, base, aliases = []) => {
    const values = [];
 
    const push = raw => toList(raw).forEach(value => {
        if (!values.some(existing => existing.toLowerCase() === value.toLowerCase())) {
            values.push(value);
        }
    });
 
    [base, `${base}_list`, ...aliases].forEach(key => push(data[key]));
 
    // numbered keys, in numeric order
    Object.keys(data)
        .filter(key => new RegExp(`^${base}[_-]?\\d+$`, 'i').test(key))
        .sort((a, b) => parseInt(a.replace(/\D/g, ''), 10) - parseInt(b.replace(/\D/g, ''), 10))
        .forEach(key => push(data[key]));
 
    return values;
};
 
// Read species + variety once, as lists
const readSpeciesVariety = data => ({
    species: collectField(data, 'species'),
    variety: collectField(data, 'variety', ['varieties'])
});
 
const joinValues = list => list.join(MULTI_VALUE_JOIN);
 
 
/* ============================================================
   TABLE
   ============================================================ */
 
const TABLE_FIELDS = [
{ key: 'product_name', label: 'Product Name' },
{ key: 'report_number', label: 'Report Number' },
{ key: 'date_of_issue', label: 'Date Of Issue' },
{ key: 'species', label: 'Species' },
{ key: 'variety', label: 'Variety' },
{ key: 'weight', label: 'Weight (ct)' },
{ key: 'ratti', label: 'Ratti (rt)' },
{ key: 'color', label: 'Color' },
{ key: 'shape', label: 'Shape' },
{ key: 'cutting_style', label: 'Cutting Style' },
{ key: 'refractive_index', label: 'Refractive Index (R.I)' },
{ key: 'birefringence', label: 'Birefringence' },
{ key: 'optic_character', label: 'Optic Character' },
{ key: 'specific_gravity', label: 'Specific Gravity (S.G)' },
{ key: 'hardness', label: 'Hardness' },
{ key: 'origin', label: 'Origin' },
{ key: 'comments', label: 'Comments' },
{ key: 'artificial_faces', label: 'Artificial Faces' },
{ key: 'test_carried_out', label: 'Test Carried Out' }
];
 
// true  = always show every row (blank ones show "—")
// false = hide a row when it has no value
const SHOW_EMPTY_ROWS = false;
 
const buildTable = (data, sv) => {
    $.table.innerHTML = '';
 
    const addRow = (label, value) => {
        const present = hasValue(value);
        if (!present && !SHOW_EMPTY_ROWS) return;   // skip blanks when configured
 
        const row = document.createElement('tr');
        const th  = document.createElement('th');
        th.textContent = label;
 
        const td = document.createElement('td');
        td.textContent = present ? value : '—';
 
        // allow one-value-per-line display when MULTI_VALUE_JOIN is a newline
        if (MULTI_VALUE_JOIN.indexOf('\n') !== -1) td.style.whiteSpace = 'pre-line';
 
        row.appendChild(th);
        row.appendChild(td);
        $.table.appendChild(row);
    };
 
    const hasSpecies = sv.species.length > 0;
    const hasVariety = sv.variety.length > 0;
 
    // Render every field in the exact order defined in TABLE_FIELDS
    TABLE_FIELDS.forEach(field => {
 
        // Species row — also the slot where the combined row appears
        if (field.key === 'species') {
            if (hasSpecies && hasVariety) {
                addRow('Species', joinValues(sv.species));           // both filled -> separate rows
            } else if (hasSpecies || hasVariety) {
                addRow(COMBINED_SV_LABEL,                            // only one filled -> combined row
                       joinValues(hasSpecies ? sv.species : sv.variety));
            } else {
                addRow(COMBINED_SV_LABEL, '');                       // neither -> obeys SHOW_EMPTY_ROWS
            }
            return;
        }
 
        // Variety row — only when it is not already covered by the combined row
        if (field.key === 'variety') {
            if (hasSpecies && hasVariety) addRow('Variety', joinValues(sv.variety));
            return;
        }
 
        addRow(field.label, data[field.key]);
    });
};
 
 
/* ============================================================
   CARD
   ============================================================ */
 
const populateCard = (data, certId) => {
    //  Image
    if (hasValue(data.s3_url)) {
        $.image.src = data.s3_url;
        $.image.style.display = 'block';
        $.placeholder.style.display = 'none';
        $.zoom.style.display = 'flex';
    } else {
        imageFallback();
    }
    $.image.onerror = imageFallback;
 
    //  Species / Variety (may each hold several values)
    const sv = readSpeciesVariety(data);
 
    //  Title: Product Name, fallback to Species - Variety, then report number / certId
    let titleText = hasValue(data.product_name) ? String(data.product_name).trim() : '';
 
    if (!titleText) {
        const species = joinValues(sv.species);
        const variety = joinValues(sv.variety);
 
        if (species && variety) {
            titleText = `${species} - ${variety}`;
        } else if (species) {
            titleText = species;
        } else if (variety) {
            titleText = variety;
        } else {
            titleText = data.report_number || certId || 'Gemstone Report';
        }
    }
 
    $.title.textContent = titleText;
 
    //  Report number
    $.report.textContent = `REPORT NO: ${
        data.report_number || data.product_serial_number || certId || '—'
    }`;
 
    //  Table
    buildTable(data, sv);
};
 
// Button loading state
const buttonLoading = status => {
    $.button.disabled = status;
    $.button.innerHTML = status ? 'Verifying...' : 'Verify';
};
 
// Fetch certificate from API
const fetchCertificate = async certId => {
 
    const url = `${API_BASE}/${encodeURIComponent(certId)}`;
 
    console.log('Request URL:', url);
 
    const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        }
    });
 
    console.log('Status:', response.status);
    console.log('Status Text:', response.statusText);
 
    // Response body sirf ek baar read karo
    const data = await response.json();
 
    console.log('Response:', data);
 
    // Certificate nahi mila
    if (response.status === 404) {
        return {
            success: false,
            data: null
        };
    }
 
    // Kisi aur server error ke liye
    if (!response.ok) {
        throw new Error(data.message || `HTTP ${response.status}`);
    }
 
    return data;
};
 
// Main lookup
const lookupCertificate = async () => {
    const certId = $.input.value.trim().toUpperCase();
    if (!certId) return;
 
    buttonLoading(true);
    showState($.loading);
 
    try {
        const result = await fetchCertificate(certId);
 
        if (!result.success || !result.data) {
            showState($.notFound);
            return;
        }
        populateCard(result.data, certId);
        showState($.card);
    } catch (error) {
        $.error.textContent = error.message || 'Server Error';
        showState($.apiError);
    } finally {
        buttonLoading(false);
    }
};
 
// Lightbox
const openLightbox = () => {
    if (!$.image.src) return;
    $.lightboxImg.src = $.image.src;
    $.lightboxCaption.textContent = $.title.textContent;
    $.lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
};
 
const closeLightbox = () => {
    $.lightbox.classList.remove('open');
    document.body.style.overflow = '';
};
 
// Events
$.button.addEventListener('click', lookupCertificate);
$.input.addEventListener('keydown', e => { if (e.key === 'Enter') lookupCertificate(); });
$.image.addEventListener('click', openLightbox);
$.zoom.addEventListener('click', openLightbox);
$.lightboxClose.addEventListener('click', closeLightbox);
$.lightbox.addEventListener('click', e => { if (e.target === $.lightbox) closeLightbox(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
 
// Default
showState($.idle);